import styled, { css } from 'styled-components';
import { ifNotProp, switchProp } from 'styled-tools';
import { media } from '@prisjakt/ui-base';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const DEFAULT_STORE_LOGO_MAX_WIDTH = 68;
const DEFAULT_STORE_LOGO_MAX_HEIGHT = 31;

export enum VARIANTS {
  DEFAULT = 'DEFAULT',
  CAMPAIGN = 'CAMPAIGN',
  HEADING = 'HEADING',
  REVIEWS = 'REVIEWS',
  PRICE_LIST = 'PRICE_LIST',
}

export const campaignImageHeight = 31;

const defaultNoLogoCss = css`
  font-size: 12px;
  line-height: 1.3em;
  display: flex;
  align-items: center;
`;

const priceListNoLogoCss = css`
  ${defaultNoLogoCss}
  max-height: ${DEFAULT_STORE_LOGO_MAX_HEIGHT}px;
  overflow: hidden;
  align-items: normal;
`;

const campaignNoLogoCss = css`
  font-size: 10px;
  color: ${p => p.theme.colors.base700};
  max-width: 100%;
  height: ${campaignImageHeight}px;
  line-height: ${campaignImageHeight}px;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border: 1px solid ${p => p.theme.colors.base200};
  ${media.mediumUp`
    font-size: 12px;
  `};
`;

const reviewsNoLogoCss = css`
  color: ${p => p.theme.colors.maybeBlue700};
  text-decoration: underline;
`;

type StoreLogoProps = {
  showLogo: boolean;
  variant: 'DEFAULT' | 'CAMPAIGN' | 'HEADING' | 'REVIEWS' | 'PRICE_LIST';
  logoWidth: number;
  showHighResolutionLogo: boolean;
};

export const StoreLogo = styled.div<StoreLogoProps>(
  props => css`
    max-width: ${props.showHighResolutionLogo
      ? props.logoWidth / 2
      : props.logoWidth}px;

    ${media.smallOnly`
      max-width: ${
        props.showHighResolutionLogo
          ? DEFAULT_STORE_LOGO_MAX_WIDTH
          : props.logoWidth
      }px;
  `};

    ${ifNotProp(
      'showLogo',
      switchProp('variant', {
        [VARIANTS.DEFAULT]: defaultNoLogoCss,
        [VARIANTS.HEADING]: defaultNoLogoCss,
        [VARIANTS.PRICE_LIST]: priceListNoLogoCss,
        [VARIANTS.CAMPAIGN]: campaignNoLogoCss,
        [VARIANTS.REVIEWS]: reviewsNoLogoCss,
      })
    )};
  `
);

export const StoreLogoText = styled(CaptionText)`
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
`;
